const VALUE_PREFIX_DEFAULT = ':'

/**
 * !! JS has Template Literals https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals which does the work well
 * This fillString function though allows to use apiEndpoints such as 'url/:variable' making it clearer to read and compare the api routers
 *
 * Will replace :values from the string
 * @param {String} stringPattern
 * @param {Object|undefined} values Object {param:value}
 * @param {Object} [options]
 * @param {String} [options.valuePrefix]
 * @param {Boolean} [options.skipUndefined] Not implemented
 * @returns
 */
export function fillString (stringPattern, values, options) {
  let _stringPattern = stringPattern

  const valuePrefix = typeof options?.valuePrefix === 'string' ? options?.valuePrefix : VALUE_PREFIX_DEFAULT

  if (!values) return stringPattern

  Object.keys(values)?.forEach(function (oneParam) {
    const paramTarget = valuePrefix + oneParam

    _stringPattern = _stringPattern.replaceAll(paramTarget, values[oneParam])
  })
  return _stringPattern
}
